import ResponsiveHelper from "../utils/ResponsiveHelper";

export default class ProductList {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.initResponsiveHelper();
    this.initMobileFilterOverlay();
    if(this.dom.querySelector("#productfilter")){
     this.initDesktopFilterSearch();
     this.updateCartcountDown;
    }
  }
  initDesktopFilterSearch(){
    this.dom.querySelectorAll('input.product-cat-filter').forEach((product_cat) => {
      product_cat.addEventListener('change', (e)=>{
        clearTimeout(this.updateCartcountDown);
        this.updateCartcountDown = setTimeout(()=>{
          document.querySelector('body').classList.add("noscroll","open-loading-overlay");
          this.dom.querySelector("#productfilter").submit();
      }, 500);
      });
    });
    // let inputBox = this.dom.querySelector('input[name=product_cat]');
    // inputBox.addEventListener('change', (e)=>{
    //     console.log(e.value);
    //   });

  }
  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    window.addEventListener("onBreakpointChange", (e) => {
      //console.log(e.detail);
    });
  }

  initMobileFilterOverlay() {
    const btn = this.dom.querySelector("[js-m-p-filter-btn]");
    const overlay = this.dom.querySelector("[js-m-p-f-overlay]");
    const closeBtn = this.dom.querySelector("[js-m-p-f-close-btn]");
    const body = document.body;

    if (btn) {
      btn.addEventListener("click", () => {
        // console.log("here");
        overlay.classList.add("opened");
        body.classList.add("noscroll");
        closeBtn.addEventListener("click", () => {
          overlay.classList.remove("opened");
          body.classList.remove("noscroll");
        });
      });
    }
  }

  resize() {
    // console.log("resize from Homepage.js");
  }
}
